import React from 'react';
import { Stack } from '@mui/material';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import Typography from 'new/elements/TypographySupport';

interface CapsuleClusterChipProps {
  name: string;
}

export function CapsuleClusterChip({ name }: CapsuleClusterChipProps) {
  return (
    <Stack direction="row" gap="4px" alignItems="center">
      <span style={{ color: 'var(--color-success-500)', fontSize: 'var(--font-size-sm)' }}>●</span>
      <StorageOutlinedIcon sx={{ fontSize: 16, color: 'var(--color-greyscale-600)' }} />
      <Typography sx={{ textWrap: 'nowrap' }} color="basic" variant="overline">
        {name}
      </Typography>
    </Stack>
  );
}
